class Product {
  /**
   * @type {Product}
   */
  product;
  /**
   *
   * @param productElement {Element}
   * @param sellingPlanGroups {SellingPlanGroup[]}
   */
  constructor(productElement, sellingPlanGroups) {
    this.productElement = productElement;
    this.productId = this.productElement.getAttribute('id');
    this.product = JSON.parse(this.productElement.getAttribute('data-product'));
    if (!this.productId) {
      throw new Error('No product id found.');
    }

    if (!this.product) {
      throw new Error('No product data found.');
    }

    this.#updateProductPrice(sellingPlanGroups);
  }

  /**
   *
   * @param selector {string}
   * @param sellingPlanGroups {SellingPlanGroup[]}
   */
  static createProducts(selector, sellingPlanGroups) {
    const res = [];
    document.querySelectorAll(selector)
      .forEach((el) => res.push(new Product(el, sellingPlanGroups)));
    return res;
  }

  /**
   *
   * @param sellingPlanGroups {SellingPlanGroup[]}
   * @return {void}
   */
   #updateProductPrice(sellingPlanGroups) {
    const sellingPlanGroup = sellingPlanGroups.find((group) => group.product_variants.some(({product_id}) => product_id === this.productId) );
    const [sellingPlan] = sellingPlanGroup?.selling_plans ?? [];
    if (!sellingPlan) {
      console.error('No Selling plans found.');
      return;
    }
    const [priceAdjustment] = sellingPlan?.price_adjustments ?? [];
    const finalPrice = getProductPrice(this.product.price, priceAdjustment);
    const productPrice = formatPrice(this.product.price)

    const basePriceEl = this.productElement.querySelector('.price__base');
    const finalPriceEl = this.productElement.querySelector('.price__final');
    if (finalPrice !== productPrice) {
      basePriceEl.innerText = `$${formatPriceWithoutTrailingZeros(productPrice)}`;
      finalPriceEl.innerText = `$${formatPriceWithoutTrailingZeros(finalPrice)}`;
    } else {
      basePriceEl.style.display = 'none';
      finalPriceEl.innerText = `$${formatPriceWithoutTrailingZeros(finalPrice)}`;
    }

    const productMeta = JSON.parse(this.productElement.getAttribute('data-product-meta'));
    if (!productMeta) {
      throw new Error('No product meta data found.');
    }
    const servingPrice = finalPrice / productMeta.per_pack;
    this.productElement.querySelector('.price__serving-price').innerText = `/ $${formatPriceWithoutTrailingZeros(servingPrice)} per serving`;
  }
}
